import { render, staticRenderFns } from "./InquiryRequestList.vue?vue&type=template&id=79aa1f94&scoped=true"
import script from "./InquiryRequestList.vue?vue&type=script&lang=ts"
export * from "./InquiryRequestList.vue?vue&type=script&lang=ts"
import style0 from "./InquiryRequestList.vue?vue&type=style&index=0&id=79aa1f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aa1f94",
  null
  
)

export default component.exports